(function () {
  function start() {
    document.querySelectorAll('[data-a1-outfit-guide]').forEach(function (guide) {
      if (guide.dataset.ready) return;
      guide.dataset.ready = 'true';
      var panel = guide.querySelector('.a1-omg__panel'), lastOpener;
      var tabs = Array.prototype.slice.call(guide.querySelectorAll('[data-a1-omg-tab]'));
      var panes = Array.prototype.slice.call(guide.querySelectorAll('[data-a1-omg-pane]'));
      function select(name) {
        var available = tabs.some(function (tab) { return tab.dataset.a1OmgTab === name; });
        name = available ? name : 'neck';
        tabs.forEach(function (tab) { tab.setAttribute('aria-selected', String(tab.dataset.a1OmgTab === name)); });
        panes.forEach(function (pane) { pane.hidden = pane.dataset.a1OmgPane !== name; });
      }
      function close() {
        guide.hidden = true; document.documentElement.classList.remove('a1-omg-open');
        if (lastOpener) lastOpener.focus();
      }
      function open(name, opener) {
        lastOpener = opener; select(name); guide.hidden = false;
        document.documentElement.classList.add('a1-omg-open'); panel.focus();
      }
      tabs.forEach(function (tab) { tab.addEventListener('click', function () { select(tab.dataset.a1OmgTab); }); });
      guide.querySelectorAll('[data-a1-omg-close]').forEach(function (button) { button.addEventListener('click', close); });
      document.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-a1-outfit-measure]');
        if (opener) { event.preventDefault(); open(opener.dataset.a1OutfitMeasure, opener); }
      });
      document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !guide.hidden) close(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
